import React from "react";
import VotersListComponent from "./VotersList";

const VotersList = () => {
    return <VotersListComponent />;
};

export default VotersList;
